import {config} from "@mobiusjs/site-client";

let prodConfig = {}
try {
    prodConfig = require('./config.prod').default
} catch (e) {
    console.log('No production config defined')
}

export default {
    ...config,
    options: require('./config.options').default(config.options),
    version: '2.0.5',
    debug: true,
    soon: false,
    prefix: 'oldcity_',
    name: 'oldcity_site',
    title: 'Old City Tours',
    description: "",
    robots: "noindex, nofollow",
    directives: {
        connectSrc: [
            "api.oldcity.tours", "www.oldcity.tours", "cdn.touryup.com",
            "*.elfsight.com"
        ],
        imgSrc: [
            "blob:", "cdn.touryup.com", "www.oldcity.tours",
            "*.tripadvisor.com", "*.elfsight.com", "elfsight.com", "*.tile.osm.org"
        ],
        fontSrc: [
            "data:"
        ],
        frameSrc: ['*']
    },
    modules: {
        library: {...config.modules.library},
        custom: {}
    },
    projects: {
        single: true,
        default: 'oldcity',
        projects: ['oldcity']
    },
    lang: {
        multiLang: true,
        default: 'en',
        languages: ['az', 'en', 'ru']
    },
    curr: {
        multiCurr: true,
        default: 'usd',
        currencies: ['usd', 'eur', 'azn']
    },
    company: {
        //established: 2024,
        title: 'Old City Tours'
    },
    ssl: true,
    urls: {
        api: 'api.oldcity.tours',
        cdn: 'cdn.touryup.com',
        site: 'www.oldcity.tours'
    },
    socials: {
        facebook: {url: 'oldcitytoursbaku'},
        instagram: {url: 'oldcitytours'},
    },
    css: {
        renderNodeSass: true
    },
    meta: [
        {name: 'theme-color', content: '#000'}
    ],
    contact: {
        mobile: '+994 55 699 10 50',
        email: 'info@oldcity.tours',
        whatsapp: {
            number: '994556991050',
            website: 'oldcity.tours'
        }
    },
    ...prodConfig
}
